import { effect } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TitleService } from './title.service';

export class SoftlineTitleStrategy extends TitleStrategy {
  constructor(
    protected environment: string,
    protected title: Title,
    protected service: TitleService
  ) {
    super();
    effect(() => {
      const current = this.service.title();
      if (current !== '') {
        this.title.setTitle(`${current} | ${this.environment}`);
      } else {
        this.title.setTitle(this.environment);
      }
    });
  }

  override buildTitle(snapshot: RouterStateSnapshot): string | undefined {
    return super.buildTitle(snapshot);
  }

  override updateTitle(): void {
    if (this.service.title() !== '')
      return this.title.setTitle(`${this.service.title()} | ${this.environment}`);
    return this.title.setTitle(`${this.environment}`);
  }
}
